/* England/Wales dates from https://www.gov.uk/bank-holidays.json, checked 28 September 2026.
   Calendar expires safely: renew published dates before 2029. Overrides live in header settings. */
(function () {
  'use strict';
  const BANK_HOLIDAYS = ["2026-01-01", "2026-04-03", "2026-04-06", "2026-05-04", "2026-05-25", "2026-08-31", "2026-12-25", "2026-12-28", "2027-01-01", "2027-03-26", "2027-03-29", "2027-05-03", "2027-05-31", "2027-08-30", "2027-12-27", "2027-12-28", "2028-01-03", "2028-04-14", "2028-04-17", "2028-05-01", "2028-05-29", "2028-08-28", "2028-12-25", "2028-12-26"];
  const UK = new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/London',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
  const WEEKDAYS = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  const AREAS = 'Harrow, Pinner, Northwood, Ruislip & more';
  function deliveryState(now, extraClosed = '', notice = '') {
    if (notice.trim()) return {key:'notice',message:notice.trim(),accessible:notice.trim()};
    const p = Object.fromEntries(UK.formatToParts(new Date(now)).map(x => [x.type,x.value]));
    const date = `${p.year}-${p.month}-${p.day}`;
    const calendarDay = new Date(`${date}T12:00:00Z`);
    const day = calendarDay.getUTCDay();
    const closed = new Set([...BANK_HOLIDAYS,...extraClosed.split(/[\s,;]+/).filter(x => /^\d{4}-\d{2}-\d{2}$/.test(x))]);
    const known = Number(p.year) >= 2026 && Number(p.year) <= 2028;
    const generic = {key:'calendar-unavailable',message:'Local flower delivery · Check available delivery dates',accessible:'Check available local delivery dates'};
    if (!known) return generic;
    const seconds = Number(p.hour)*3600 + Number(p.minute)*60 + Number(p.second);
    const standardCutoff = 14*3600;
    const eveningCutoff = 16*3600;
    if (day !== 0 && !closed.has(date) && seconds < eveningCutoff) {
      if (seconds < 6*3600) return {key:'early',message:'Local same-day delivery available',accessible:'Standard by 6pm: order by 2pm Monday–Saturday. Evening 4–8pm: order by 4pm Monday–Saturday.'};
      if (seconds < standardCutoff) return {key:'countdown',message:'Order within',suffix:'for same-day delivery to '+AREAS,remaining:standardCutoff-seconds,accessible:'Order by 2pm UK time for delivery by 6pm.'};
      return {key:'countdown',message:'Order within',suffix:'for same-day delivery to '+AREAS,remaining:eveningCutoff-seconds,accessible:'Order by 4pm UK time for 4–8pm delivery.'};
    }
    for (let offset=1;offset<=31;offset++) {
      const next = new Date(calendarDay.getTime()+offset*86400000);
      if(next.getUTCFullYear()>2028) return generic;
      const nextDate=next.toISOString().slice(0,10);
      const sundayBookable = next.getUTCDay() === 0 && (offset > 1 || (day === 6 && seconds < 14*3600));
      if((next.getUTCDay()!==0 || sundayBookable) && !closed.has(nextDate)) {
        const label=offset===1?'tomorrow':(offset<7?WEEKDAYS[next.getUTCDay()]:new Intl.DateTimeFormat('en-GB',{timeZone:'UTC',weekday:'long',day:'numeric',month:'long'}).format(next));
        const message='Local delivery · Order now for delivery '+label;
        return {key:'next-'+nextDate,message,accessible:message+'.'};
      }
    }
    return generic;
  }
  function earliestDelivery(now, extraClosed = '', notice = '') {
    const state = deliveryState(now, extraClosed, notice);
    if (state.key === 'notice') return 'Delivery update: '+state.message+' Check available dates when ordering.';
    if (state.key === 'early' || state.key === 'countdown') {
      const p = Object.fromEntries(UK.formatToParts(new Date(now)).map(x => [x.type,x.value]));
      const minutes = Number(p.hour)*60+Number(p.minute);
      return minutes < 840 ? 'Earliest delivery: today. Order before 2pm for delivery by 6pm, or before 4pm for our 4pm–8pm window. Choose today or a later date; subject to availability.' : 'Earliest delivery: today, 4pm–8pm. Order before 4pm (UK time), or choose a later date. Subject to availability.';
    }
    if (state.key.startsWith('next-')) {
      const date = new Date(state.key.slice(5)+'T12:00:00Z');
      const label = new Intl.DateTimeFormat('en-GB',{timeZone:'UTC',weekday:'long',day:'numeric',month:'long'}).format(date);
      return 'Earliest delivery: '+(state.message.endsWith('tomorrow')?'tomorrow, ':'')+label+'. Subject to availability.';
    }
    return 'Earliest delivery: check available dates when ordering.';
  }
  function phoneState(now, extraClosed = '') {
    const p = Object.fromEntries(UK.formatToParts(new Date(now)).map(x => [x.type,x.value]));
    const date = `${p.year}-${p.month}-${p.day}`;
    const calendarDay = new Date(`${date}T12:00:00Z`);
    const day = calendarDay.getUTCDay();
    const closed = new Set([...BANK_HOLIDAYS,...extraClosed.split(/[\s,;]+/)]);
    const known = Number(p.year) >= 2026 && Number(p.year) <= 2028;
    if (!known) return {key:'unknown',hours:'Mon–Fri 10am–6pm · Sat 10am–4pm',message:'Call us',note:''};
    const minutes = Number(p.hour)*60 + Number(p.minute);
    const todayAvailable = day !== 0 && !closed.has(date);
    const open = todayAvailable && minutes >= 600 && minutes < (day === 6 ? 960 : 1080);
    if (open) return {key:'open',hours:'Open now · 10am–'+(day===6?'4pm':'6pm'),message:'Phone lines open',note:''};
    for (let offset = 0; offset <= 31; offset++) {
      const next = new Date(calendarDay.getTime()+offset*86400000);
      if (next.getUTCFullYear()>2028) break;
      const nextDate = next.toISOString().slice(0,10);
      if (next.getUTCDay()===0 || closed.has(nextDate) || (offset===0 && minutes>=600)) continue;
      const label = offset===0?'today':offset===1?'tomorrow':offset<7?WEEKDAYS[next.getUTCDay()]:new Intl.DateTimeFormat('en-GB',{timeZone:'UTC',weekday:'long',day:'numeric',month:'long'}).format(next);
      return {key:'closed',hours:'Re-opens 10am '+label,message:'Leave a message',note:''};
    }
    return {key:'closed',hours:'Shop closed · Check opening hours',message:'Leave a message',note:''};
  }
  function phoneHours(now, extraClosed = '') { return phoneState(now, extraClosed).hours; }
  function mountPhone(root) {
    if (root.dataset.vaPhoneReady) return;
    root.dataset.vaPhoneReady = 'true';
    const server = Number(root.dataset.serverNow)*1000;
    const initial = Number.isFinite(server) && server > 0 ? server : Date.now();
    const started = performance.now();
    const hours=root.querySelector('[data-va-shop-hours]'),status=root.querySelector('[data-va-phone-status]'),note=root.querySelector('[data-va-phone-note]');
    function update() {
      if (!root.isConnected) { clearInterval(interval); return; }
      const now=initial + performance.now() - started;
      const state=phoneState(now,root.dataset.closedDates || '');
      const shop=phoneState(now,root.dataset.shopClosedDates || '');
      if(hours && status){hours.textContent=shop.hours;hours.dataset.state=shop.key;status.textContent=state.message;status.dataset.state=state.key;if(note){note.textContent=state.note;note.hidden=!state.note;}}
      else root.textContent=state.hours+' · '+state.message+(state.note?' · '+state.note:'');
    }
    const interval = setInterval(update, 30000);
    update();
  }
  function formatRemaining(seconds) {
    const hours=Math.floor(seconds/3600);
    return `${hours ? hours+'h ' : ''}${Math.floor(seconds%3600/60)}m ${seconds%60}s`;
  }
  if(typeof module!=='undefined' && module.exports) module.exports={deliveryState,earliestDelivery,formatRemaining,phoneHours,phoneState};
  if(typeof document==='undefined') return;
  function mount(root) {
    if(root.dataset.vaCountdownReady) return;
    root.dataset.vaCountdownReady='true';
    const message=root.querySelector('[data-va-delivery-message]');
    const timer=root.querySelector('[data-va-delivery-timer]');
    const areas=root.querySelector('[data-va-delivery-areas]');
    const link=root.querySelector('[data-va-delivery-link]');
    const status=root.querySelector('[data-va-delivery-status]');
    const server=Number(root.dataset.serverNow)*1000;
    const initial=Number.isFinite(server)&&server>0?server:Date.now();
    const started=performance.now();
    window.VaLocalDelivery = {earliest: () => earliestDelivery(initial+performance.now()-started,root.dataset.closedDates||'',root.dataset.notice||'')};
    let previous='';
    function update() {
      if(!root.isConnected){clearInterval(interval);return;}
      const state=deliveryState(initial+performance.now()-started,root.dataset.closedDates||'',root.dataset.notice||'');
      const mobile=matchMedia('(max-width:749px)').matches;
      message.textContent=mobile&&state.key==='countdown'?'Same-day delivery · Order in':mobile?state.message.replace('Local delivery · ','').replace('Local flower delivery · Check available delivery dates','Choose your delivery day').replace('Local same-day delivery available','Same-day delivery available'):state.message;
      timer.textContent=state.remaining===undefined?'':formatRemaining(state.remaining);
      if(areas) areas.textContent=state.key==='notice'?'':(state.suffix||'· '+AREAS);
      if(state.key!==previous) {
        link.setAttribute('aria-label',state.accessible+(state.key==='countdown'||state.key==='notice'?'':' Delivery areas: '+AREAS+'.'));
        if(previous) status.textContent=state.accessible;
        previous=state.key;
      }
    }
    const interval=setInterval(update,1000); update();
  }
  function init(){document.querySelectorAll('[data-va-delivery-banner]').forEach(mount);document.querySelectorAll('[data-va-phone-hours]').forEach(mountPhone);}
  init(); document.addEventListener('shopify:section:load',init);
})();
